import { CostReportData } from './export';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapOrgReportToCostReportData = (report: any): CostReportData => ({
  accountName: report.account_name,
  reportDate: report.time_now.split('T')[0],
  generatedBy: 'EazyOps Engine',
  resourceCount: report.resource_count,
  timeline: report.timeline,
  timelineDate: report.time_now.split('T')[0],

  savingsPercentage: report.savings_percentage,
  monthlySaving: report.monthly_saving,
  yearlySaving: report.annual_saving,
  monthlySpend: report.monthly_spend,
  yearlySpend: report.annual_spend,

  // Convert resource summary
  resourcesSummary: Object.entries(report.resources).map(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([key, value]: any) => ({
      name: key
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c: string) => c.toUpperCase()),
      monthlyCost: value.monthly_cost,
      monthlySavings: value.monthly_saving,
      yearlyCost: value.annual_cost,
      yearlySavings: value.annual_saving,
    })
  ),

  // Projects mapping
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  projects: report.projects.map((p: any) => ({
    name: p.project_name,
    resourceCount: p.resources_count,
    monthlySpend: p.monthly_spending,
    monthlySaving: p.monthly_saving,
    savingPercent: p.monthly_spending
      ? Math.round((p.monthly_saving / p.monthly_spending) * 100)
      : 0,
  })),

  // Recommendations
  recommendations: {
    immediate: report.strategic_recommendations.immediate_actions,
    midTerm: report.strategic_recommendations.mid_term_actions,
    longTerm: report.strategic_recommendations.long_term_actions,
  },

  // Complexity mapping
  complexity: Object.entries(report.implementation_complexity).map(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([key, value]: any) => ({
      name: key
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c: string) => c.toUpperCase()),
      level: value,
    })
  ),
});
